<div class="stakeholder-user-list-item">
  {{ label }}

  <i class="far fa-trash-can" (click)="deleteClick.emit()"></i>
</div>
